// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/*
 * Copyright (c) 2024 by N-Ach (Pvt) Ltd
 *
 * ╔═╗ ╔╗    ╔═══╗  ╔╗
 * ║║╚╗║║    ║╔═╗║  ║║
 * ║╔╗╚╝║    ║║ ║╠══╣╚═╗
 * ║║╚╗║║╔══╗║╚═╝║╔═╣╔╗║
 * ║║ ║║║╚══╝║╔═╗║╚═╣║║║
 * ╚╝ ╚═╝    ╚╝ ╚╩══╩╝╚╝
 *
 * All rights reserved.
 *
 * This software is the confidential and proprietary information
 * of N-Ach (Pvt) Ltd. You shall not disclose such Confidential
 * Information and shall use it only in accordance with the terms
 * of the license agreement you entered into with N-Ach (Pvt) Ltd.
 *
 *
 * @Author Dilhari Jayathunga
 * @Date 4/12/2024
 */

 .Notification_formLabel__UMftQ {
    font-weight: 600 !important;
  }
  
  .Notification_formItem__FoEOL {
    margin-top: 1rem !important;
  }
  
  .Notification_formText__ct4AP {
    margin-top: 0.3rem !important;
  }
  
  .Notification_popoverPaper__LqjRJ {
    width: '100%';
    height: '100%';
    max-height: 'unset';
    left: 5% !important;
  }
  
  .Notification_validation__w29G- {
    color: red;
  }
  
  .Notification_closeButton__A4ITC {
    padding: 0.2rem;
    border: 1px #47C2BB solid;
    color: #47C2BB;
  }`, "",{"version":3,"sources":["webpack://./src/Components/Notification/Notification.module.css"],"names":[],"mappings":"AAAA;;;;;;;;;;;;;;;;;;;;EAoBE;;CAED;IACG,2BAA2B;EAC7B;;EAEA;IACE,2BAA2B;EAC7B;;EAEA;IACE,6BAA6B;EAC/B;;EAEA;IACE,aAAa;IACb,cAAc;IACd,mBAAmB;IACnB,mBAAmB;EACrB;;EAEA;IACE,UAAU;EACZ;;EAEA;IACE,eAAe;IACf,yBAAyB;IACzB,cAAc;EAChB","sourcesContent":["/*\r\n * Copyright (c) 2024 by N-Ach (Pvt) Ltd\r\n *\r\n * ╔═╗ ╔╗    ╔═══╗  ╔╗\r\n * ║║╚╗║║    ║╔═╗║  ║║\r\n * ║╔╗╚╝║    ║║ ║╠══╣╚═╗\r\n * ║║╚╗║║╔══╗║╚═╝║╔═╣╔╗║\r\n * ║║ ║║║╚══╝║╔═╗║╚═╣║║║\r\n * ╚╝ ╚═╝    ╚╝ ╚╩══╩╝╚╝\r\n *\r\n * All rights reserved.\r\n *\r\n * This software is the confidential and proprietary information\r\n * of N-Ach (Pvt) Ltd. You shall not disclose such Confidential\r\n * Information and shall use it only in accordance with the terms\r\n * of the license agreement you entered into with N-Ach (Pvt) Ltd.\r\n *\r\n *\r\n * @Author Dilhari Jayathunga\r\n * @Date 4/12/2024\r\n */\r\n\r\n .formLabel {\r\n    font-weight: 600 !important;\r\n  }\r\n  \r\n  .formItem {\r\n    margin-top: 1rem !important;\r\n  }\r\n  \r\n  .formText {\r\n    margin-top: 0.3rem !important;\r\n  }\r\n  \r\n  .popoverPaper {\r\n    width: '100%';\r\n    height: '100%';\r\n    max-height: 'unset';\r\n    left: 5% !important;\r\n  }\r\n  \r\n  .validation {\r\n    color: red;\r\n  }\r\n  \r\n  .closeButton {\r\n    padding: 0.2rem;\r\n    border: 1px #47C2BB solid;\r\n    color: #47C2BB;\r\n  }"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"formLabel": `Notification_formLabel__UMftQ`,
	"formItem": `Notification_formItem__FoEOL`,
	"formText": `Notification_formText__ct4AP`,
	"popoverPaper": `Notification_popoverPaper__LqjRJ`,
	"validation": `Notification_validation__w29G-`,
	"closeButton": `Notification_closeButton__A4ITC`
};
export default ___CSS_LOADER_EXPORT___;
